import { render } from "./Thongkedoanhthu.vue?vue&type=template&id=56fbfe36&scoped=true&ts=true"
import script from "./Thongkedoanhthu.vue?vue&type=script&lang=ts"
export * from "./Thongkedoanhthu.vue?vue&type=script&lang=ts"

import "./Thongkedoanhthu.vue?vue&type=style&index=0&id=56fbfe36&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Dashboard_YHCT/Dashboard_FE_YHCT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fbfe36"]])

export default __exports__